import {
  Box,
  Button,
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
  Container,
  Divider,
  Grid,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import YouTubeIcon from "@mui/icons-material/YouTube";
import { fetchAllVideos } from "../firebase/fireStoreServices";
import { useNavigate } from "react-router-dom";

export default function VideosSection() {
  /* const videos = [
    {
      id: 1,
      title: "Manchurian with Fried Rice",
      thumbnail: "/images/videos/ManchurianFriedRice.jpg",
      url: "https://youtu.be/zsaNR1SceRg",
    },
    {
      id: 2,
      title: "Dahi Balle",
      thumbnail: "/images/videos/DahiBalle.jpg",
      url: "https://youtu.be/xknZ0y-C1fU",
    },
    {
      id: 3,
      title: "Ras Malai",
      thumbnail: "/images/videos/RasMalai.jpg",
      url: "https://youtu.be/VREV_BEmjII",
    },
  ];
  */
  const navigate = useNavigate();
  const [selectedVideo, setSelectedVideo] = useState(null);

  const [videos, setVideos] = useState([]);
  // Fetching Blog data from database through service layer i.e. firebase/fireStoreServices
  useEffect(() => {
    const loadVideos = async () => {
      const videosData = await fetchAllVideos();
      setVideos(videosData);
    };
    loadVideos();
  }, []);

  const displayedVideos = videos.slice(0, 3); // Limit 3 products to be displayed only

  return (
    <Container maxWidth="lg" sx={{ mt: 3, bgcolor: "white", borderRadius: 4 }}>
      <Divider>
        <Typography
          variant="h4"
          fontWeight="bold"
          color="secondary"
          sx={{ my: 4, textAlign: "center" }}
        >
          Latest YouTube Videos 🎥
        </Typography>
      </Divider>

      <Box sx={{ mt: 1, p: 3 }}>
        <Grid container spacing={3}>
          {displayedVideos.map((video) => (
            <Grid item xs={12} sm={6} md={4} key={video.id}>
              <Card
                sx={{
                  boxShadow: 3,
                  borderRadius: 2,
                  transition: "transform 0.3s, box-shadow 0.3s",
                  "&:hover": {
                    transform: "scale(1.05)",
                    boxShadow: 15,
                  },
                }}
              >
                <CardActionArea onClick={() => setSelectedVideo(video.url)}>
                  <CardMedia
                    component="img"
                    height="200"
                    image={video.thumbnail}
                    alt={video.title}
                    sx={{ objectFit: "cover", width: "100%" }}
                  />
                  <CardContent>
                    <Typography
                      variant="h6"
                      fontWeight="bold"
                      sx={{ textAlign: "center" }}
                    >
                      {video.title}
                      <YouTubeIcon />
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>
          ))}
        </Grid>
        <Box textAlign="center" mt={4}>
          <Button
            variant="contained"
            color="secondary"
            onClick={() => navigate("/all-videos")}
          >
            View All Videos
          </Button>
        </Box>
      </Box>

      {/* Display Selected Video */}
      {selectedVideo && (
        <Box sx={{ my: 4, textAlign: "center", boxShadow: 3, borderRadius: 2 }}>
          <iframe
            width="100%"
            height="400"
            src={`https://www.youtube.com/embed/${selectedVideo.replace(
              "https://youtu.be/",
              ""
            )}?autoplay=1&rel=0`}
            title="YouTube Video"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </Box>
      )}
    </Container>
  );
}
